import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  
  title: {
    fontSize: 14,
  },
  selectEmpty: {
    marginTop: theme.spacing(3),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(2),
  },
  formControl: {
    marginBottom: theme.spacing(2)
  }
}))

const CampaignForm = ({ existingCampaigns, campaignName, setCampaignName, selectedCampaign, setSelectedCampaign }) => {
  const classes = useStyles()

  return (
    <div className={classes.form}>
       <FormControl className={classes.formControl} fullWidth>
        <InputLabel shrink id='campaign'>
          Existing Campaign
        </InputLabel>
        <Select
          disabled={campaignName.length > 0 || existingCampaigns.length === 0}
          labelId='campaign'
          id='demo-simple-select-placeholder-label'
          value={selectedCampaign}
          onChange={({ target }) => setSelectedCampaign(target.value)}
          displayEmpty
          className={classes.selectEmpty}
        >
          <MenuItem value=''>
            <em>{existingCampaigns.length === 0 ? 'No existing campaigns available' : 'No campaign selected'}</em>
          </MenuItem>
          {existingCampaigns.map((campaign) => {
            return <MenuItem key={campaign.campaignId} value={campaign.campaignId}>{campaign.campaignName}</MenuItem>
          })}
        </Select>
      </FormControl>
      <p style={{ textAlign: 'center', opacity: selectedCampaign.length > 0 ? 0.5 : 1 }}>or</p>
      <TextField
        disabled={selectedCampaign.length > 0}
        fullWidth
        margin='normal'
        variant='outlined'
        label='New Campaign'
        InputLabelProps={{ shrink: true }}
        type='text'
        value={campaignName}
        onChange={({ target }) => {
          setCampaignName(target.value)
        }}
        css={`opacity: ${selectedCampaign.length > 0 ? 0.5 : 1};`}
      />
    </div>
  )
}

export default CampaignForm
